// @flow
import { DelayedRedirect } from "views/components/common/DelayedRedirect";
import { ErrorMessage } from "views/components/Message";
import { FlatButton } from "views/components/FlatButton";
import { Form, Password } from "views/components/common/Form";
import { Onboarding } from "views/desktop/components/Welcome";
import { Spacer } from "views/components/common/Spacer";
import { useUpdatePassword } from "state/users/hooks";
import React, { useDispatch, useState } from "reactn";
import { PasswordLegend } from "../components/cards/PasswordLegend.jsx";

const RecoverPassword = () => {
	const code = new URLSearchParams(window.location.search).get("oobCode");

	const [inputs, updateInputs] = useState({});
	const onChange = ({ target: { name, value } }) =>
		updateInputs({ ...inputs, [name]: value });

	const [updatePassword, loading, success, error] = useUpdatePassword(code);

	if (success)
		return (
			<DelayedRedirect to="/welcome" delay={6000}>
				<Onboarding>
					<div>
						Contraseña cambiada exitosamente. Te redirigiremos a la
						página de inicio de sesión.
					</div>
				</Onboarding>
			</DelayedRedirect>
		);

	return (
		<Onboarding>
			<div>
				<h4>Crea una nueva contraseña</h4>
				<Form>
					<ErrorMessage error={error} />
					<PasswordLegend desktop password={inputs.password0 || ""} />
					<Password
						validator={(p) => p.length > 6}
						label="Nueva contraseña"
						errorMessage="La contraseña debe tener un mínimo de 6 caracteres"
						name="password0"
						value={inputs.password0}
						onChange={onChange}
					/>
					<Spacer rows={1} />
					<Password
						validator={(p) => inputs.password0 === p}
						label="Repite tu contraseña"
						errorMessage="Las contraseñas deben coincidir"
						name="password1"
						value={inputs.password1}
						onChange={onChange}
					/>
					<Spacer rows={1} />
					<FlatButton
						disabled={
							!inputs.password0 ||
							(inputs.password0 && inputs.password0.length < 6)
						}
						loading={loading}
						text="Cambiar contraseña"
						onClick={() => updatePassword(inputs)}
					/>
				</Form>
			</div>
		</Onboarding>
	);
};

export { RecoverPassword };
